import {
    BudgetLine,
    ResourceBudgetProposalAssociationT,
} from 'routes/BudgetModule/config/types';
import { translateBlockValue } from 'i18n';
import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';
import { objectWithLabelFormatter } from 'ui/AgGridReact/formatters';
import {
    NATURE_FIELD,
    NATURE_LABEL_FIELD,
    ORG_CHART_FINANCE_FIELD,
} from 'routes/BudgetModule/config/constants';
export const getResourceColumns = (
    resourceType: string,
): ColDef<ResourceBudgetProposalAssociationT>[] => [
    {
        field: 'resource',
        headerName: translateBlockValue(resourceType, true),
        valueGetter: ({ data }) => data?.resource?.resourceName ?? '',
    },
    {
        field: 'budgetProposal',
        headerName: t('addInscriptionModal.budgetProposal'),
        valueGetter: ({ data }) => data?.budgetProposal?.name ?? '',
    },
];

export const getBudgetLineColumns = (
    imputationDimensions: string[],
): ColDef<BudgetLine>[] =>
    imputationDimensions.flatMap((dim: keyof BudgetLine) => {
        const colDef: ColDef<BudgetLine> = {
            field: dim,
            headerName: translateBlockValue(dim, true),
        };

        if (dim === ORG_CHART_FINANCE_FIELD) {
            return {
                ...colDef,
                valueFormatter: objectWithLabelFormatter,
            };
        }

        if (dim === NATURE_LABEL_FIELD) {
            const natureFieldColDef: ColDef<BudgetLine> = {
                field: NATURE_FIELD,
                headerName: translateBlockValue(NATURE_FIELD, true),
            };
            return [natureFieldColDef, colDef];
        }

        return colDef;
    });
